import React, { useEffect } from 'react';

import classNames from 'classnames';

import { Layout } from 'wanderu-components';
import { fetchDailyMinimumPricingAction } from 'wanderu-ducks-pricing';
import { selectCurrency } from 'wanderu-i18n';
import { useAppDispatch, useAppSelector } from 'wanderu-shellapp';
import { getDateRange } from 'wanderu-utils';

import DayButton from './DayButton/DayButton';
import { usePricingSelector } from '../../../hooks';

import styles from './MultiDay.scss';

export interface SearchParams {
    departDate: string;
    departTripId?: string;
    destinationPlaceId?: string;
    destinationText: string;
    direction: string;
    originPlaceId?: string;
    originText: string;
    returnDate?: string;
}

interface MultiDayProps {
    searchAheadDate?: string;
    searchParams: SearchParams;
    isDesktop?: boolean;
}

export const MultiDay = ({
    searchAheadDate,
    searchParams,
    isDesktop,
}: MultiDayProps) => {
    const dispatch = useAppDispatch();
    const currency = useAppSelector(selectCurrency);

    const {
        departDate,
        destinationPlaceId,
        direction,
        originPlaceId,
    } = searchParams || {};

    const dateRange = getDateRange(departDate);

    useEffect(() => {
        dispatch(fetchDailyMinimumPricingAction.fetch({
            currency,
            destinationPlaceId,
            fromDate: dateRange[0].date,
            originPlaceId,
            toDate: searchAheadDate,
        }));
    }, [
        currency,
        dateRange,
        destinationPlaceId,
        dispatch,
        originPlaceId,
        searchAheadDate,
    ]);

    const dailyMinimumPricing = usePricingSelector({
        destinationPlaceId,
        originPlaceId,
    });

    if (!dailyMinimumPricing || direction === 'return') return null;

    return (
        <Layout className={classNames(styles.days, {
            [styles.desktop]: isDesktop,
        })}>
            {dateRange.map(({ date, isActive, isDisabled }) => (
                <DayButton
                    date={date}
                    isActive={isActive}
                    isDisabled={isDisabled}
                    key={date}
                    price={dailyMinimumPricing?.[date]}
                    searchParams={searchParams}
                />
            ))}
        </Layout>
    );
};
